import { createI18n } from 'vue-i18n'
import { store } from '../_store';

const i18n = createI18n({
  legacy: true,
  locale: 'en',
  messages: {}
})

/**
 * @param {String} locale
 */
export async function loadMessages (locale) {
  if (Object.keys(i18n.global.getLocaleMessage(locale)).length === 0) {
    const messages = await import(/* webpackChunkName: '' */ '../_lang/'+locale)
    i18n.global.setLocaleMessage(locale, messages.default || messages)
  }

  if (i18n.global.locale !== locale) {
    i18n.global.locale = locale
  }
}

(async function () {

  await loadMessages(store.getters['lang/locale'])
})()

export default i18n
